module.exports = __webpack_public_path__ + "static/media/icon_file.3a0bbb87.svg";